<div *ngIf="model" class="component-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align section-heading text-uppercase">
      <div class="ui-g-12">
        <app-section-header
          [title]="'regep.commissioning-of-energy-producer.title' | translate"
          [tooltip]="'tooltips.technical-data.regep.commissioning-of-energy-producer' | translate"></app-section-header>
      </div>
      <div class="section-buttons">
        <lock-unlock-buttons
          [showLockButton]="isDetailsView"
          [showUnlockButton]="isDetailsView"
          [isLocked]="getSectionLocked()"
          [areButtonsDisabled]="!(isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles)"
          (lockButtonClickedEvent)="lockSection()"
          (unLockButtonClickedEvent)="unlockSection()"></lock-unlock-buttons>
        <i
          *ngIf="isDetailsView"
          class="pi pi-comment"
          [ngClass]="isCommentVisible || getSectionComment() ? 'lock-icon-style' : 'unlock-icon-style'"
          [pTooltip]="showCommentTooltip() ? ('comment-section.comment-tooltip' | translate) : null"
          [tooltipPosition]="showCommentTooltip() ? 'bottom' : null"
          (click)="showComment()"></i>
      </div>
    </div>
  </div>
  <section-comment
    [isCommentTextInputVisible]="isModeratorRole() && (isCommentVisible || getSectionComment())"
    [isCommentTextVisible]="!isModeratorRole()"
    [isCommentSaveVisible]="!getSectionComment()"
    [isCommentDeleteButtonDisabled]="!editabilityBasedOnProcessStatus.internalRoles"
    [comment]="getSectionComment()"
    (saveCommentEvent)="updateComment($event)"
    (deleteCommentEvent)="deleteComment()"
    (changeTextEvent)="changeCommentText.emit($event)"></section-comment>
  <div [ngClass]="{ 'disable-section': getSectionLocked() && applicationId }" class="section-wrapper margin-align">
    <div class="margin-align">
      <div class="section-column top-bottom-margin">
        <div class="section-field">
          <label class="ui-g-5 field-label"></label>
          <p-checkbox
            [(ngModel)]="model.commissioning_date_unknown"
            (ngModelChange)="commissioningDateUnknownChange($event)"
            binary="true"
            name="commissioning_date_unknown"
            label="{{ 'regep.commissioning-of-energy-producer.commissioning-date-unknown' | translate }}"
            [disabled]="isSectionDisabled"></p-checkbox>
        </div>

        <div class="section-field" *ngIf="model.commissioning_date_unknown">
          <label class="ui-g-5 field-label"></label>
          <span [innerHTML]="'regep.commissioning-of-energy-producer.commissioning-date-unknown-info' | translate"></span>
        </div>

        <div class="section-field" *ngIf="!model.commissioning_date_unknown">
          <label class="ui-g-5 field-label required">
            {{ 'regep.commissioning-of-energy-producer.commissioning-date' | translate }}
          </label>
          <div *ngIf="'app.calendar-settings' | translate as locale" class="ui-g-6 ui-xs-12 upload-padding">
            <p-calendar
              [locale]="locale"
              [dateFormat]="dateFormat.dateFormat"
              [placeholder]="dateFormat.placeholder"
              [monthNavigator]="true"
              [yearNavigator]="true"
              name="commissioning_date"
              [disabled]="isSectionDisabled"
              class="doc-submit-datepicker"
              dateFormat="string"
              id="commissioning_date"
              inputId="basic"
              yearRange="2023:2080"
              [required]="!model.commissioning_date_unknown"
              [(ngModel)]="model.commissioning_date"></p-calendar>
          </div>
        </div>

        <div *ngIf="!model.commissioning_date_unknown" class="field-padding section-field">
          <label class="ui-g-5 field-label required">
            {{ 'regep.commissioning-of-energy-producer.photo-documentation-of-installed-generators-and-converters' | translate }}
          </label>
          <app-file-upload
            class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
            [fileData]="model.photo_documentation_of_installed_generators_and_converters"
            [isDetailsView]="isDetailsView && model.photo_documentation_of_installed_generators_and_converters.document_id"
            [type]="registrationOfEnergyProducerApplicationDocumentTypes.PhotoDocumentationOfInstalledGeneratorsAndConverters"
            [isClearButtonDisabled]="isSectionDisabled"
            [isUploadDisabled]="isSectionDisabled"
            [isRequired]="!isModeratorRole()"
            inputName="PhotoDocumentationOfInstalledGeneratorsAndConverters"
            (clearFileEvent)="clearFile($event)"></app-file-upload>
        </div>

        <div *ngIf="!model.commissioning_date_unknown" class="field-padding section-field">
          <label class="ui-g-5 field-label required">
            {{ 'regep.commissioning-of-energy-producer.request-for-meter-mounting' | translate }}
          </label>
          <app-file-upload
            class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
            [fileData]="model.request_for_meter_mounting"
            [isDetailsView]="isDetailsView && model.request_for_meter_mounting.document_id"
            [type]="registrationOfEnergyProducerApplicationDocumentTypes.RequestForMeterMounting"
            [isClearButtonDisabled]="isSectionDisabled"
            [isUploadDisabled]="isSectionDisabled"
            [isRequired]="!isModeratorRole()"
            inputName="RequestForMeterMounting"
            (clearFileEvent)="clearFile($event)"></app-file-upload>
        </div>

        <div class="ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows pt-0 confirm-checkbox">
          <div class="ui-lg-12">
            <p-checkbox
              [(ngModel)]="model.confirm_commissioning_corresponds_to_technical_data"
              binary="true"
              name="confirm_commissioning_corresponds_to_technical_data"
              [disabled]="isSectionDisabled"></p-checkbox>
            <label class="required">
              {{ 'regep.commissioning-of-energy-producer.confirm-commissioning-corresponds-to-technical-data' | translate }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
